export const findMissingAnswers = (taskList, answerList) => {
    const wissingAnswerList = taskList.reduce((missingList, task, index) => {
        const hasAnswer = answerList.find(({ _id }) => {
            return _id === task._id;
        });
        if (hasAnswer) return missingList;
        return [...missingList, index + 1];
    }, []);
    return wissingAnswerList;
};